import React from 'react';
import { User } from '../../services/auth.service';
import { HackathonPayload } from '../../services/hackathon.service';
import { useRef } from 'react';
import Button from '@mui/material/Button/Button';
import Menu from '@mui/material/Menu/Menu';
import MenuItem from '@mui/material/MenuItem/MenuItem';
import { addMemberToIdea } from '../../services/idea.service';
import Snackbar from '@mui/material/Snackbar/Snackbar';

export const JoinTeamMenu = ({
    userEmail,
    hackathon,
    label = 'Add to Team',
    onChange
}: {
    userEmail: string,
    hackathon: HackathonPayload,
    label?: string,
    onChange: () => void
}) => {

    // their current team isn't a place to move to
    const availableIdeas = hackathon.ideas.filter(idea => !idea.archived && !idea.disqualified && !idea.members.some(m => m.email === userEmail));

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleErrorNotificationClose = () => {
        setError(null);
    }

    const [error, setError] = React.useState<string | null>(null);

    return <>
        <Snackbar
            open={!!error}
            autoHideDuration={2000}
            onClose={handleErrorNotificationClose}
            message={error}
        />
        <Button onClick={handleClick}>
            {label}
        </Button>
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}>
            {availableIdeas.map(idea => <MenuItem key={idea._id} onClick={() => {
                // Join team
                addMemberToIdea(hackathon.slug, idea._id, userEmail).then(() => {
                    onChange();
                    handleClose();
                }).catch((err) => {
                    setError(err?.response?.data?.message || err.message);
                    handleClose();
                })
            }}>
                {idea.title}</MenuItem>)}
        </Menu>
    </>
}